import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute } from '@angular/router';
import { JhiLanguageService } from '../../shared/core-utils';
import { VariableTypeEnum } from '../../shared/ontology/variable-type.enum';
import { HttpResponse } from '@angular/common/http';
import { finalize } from 'rxjs/internal/operators/finalize';
import { DatasetService } from '../../shared/dataset/service/dataset.service';
import { ObservationAudit } from '../../shared/model/observation-audit.model';
import { ObservationVariable } from '../../shared/model/observation-variable.model';
import { DateFormatEnum, formatDateToUTC } from '../../shared/util/date-utils';
import { ObservationService } from './observation.service';
import { SubscriptionsManager } from '../../shared/util/subscriptions-manager';
import { AlertService } from '../../shared/alert/alert.service';

@Component({
    selector: 'jhi-observation-details',
    templateUrl: './observation-details.component.html'
})
export class ObservationDetailsComponent implements OnInit, OnDestroy {

    @Input() observationUnitId: string;
    @Input() studyId: number;
    @Input() datasetId: number;
    cropName: number;
    programUUID: number;

    editable = false;

    selectedVariable: number;
    studyVariables = [];
    VARIABLE_TYPE_IDS;

    isLoading: boolean;
    totalItems: number;
    queryCount: number;
    page: number;
    previousPage: number;

    readonly itemsPerPage: number = 10;

    phenotypeAudits: ObservationAudit[];

    subscriptionManager = new SubscriptionsManager();

    constructor(private route: ActivatedRoute,
                public activeModal: NgbActiveModal,
                private alertService: AlertService,
                public datasetService: DatasetService,
                public observationService: ObservationService,
                private jhiLanguageService: JhiLanguageService) {
    }

    ngOnDestroy(): void {
        this.subscriptionManager.unsubscribeAll();
    }

    ngOnInit(): void {
        this.page = 1;
        this.selectedVariable = 0;

        if (this.route.snapshot.params['observationUnitId']) {
            this.observationUnitId = this.route.snapshot.params['observationUnitId'];
        }
        if (this.route.snapshot.params['studyId']) {
            this.studyId = this.route.snapshot.queryParams['studyId'];
        }
        if (this.route.snapshot.params['datasetId']) {
            this.datasetId = this.route.snapshot.queryParams['datasetId'];
        }

        (<any>window).onCloseModal = this.clear;

        this.VARIABLE_TYPE_IDS = [VariableTypeEnum.TRAIT, VariableTypeEnum.SELECTION_METHOD, VariableTypeEnum.ENVIRONMENT_CONDITION];

        this.subscriptionManager.add = this.datasetService.getObservationSetColumns(this.studyId, this.datasetId)
            .subscribe(
                (resp: HttpResponse<ObservationVariable[]>) => {
                    this.studyVariables = resp.body.filter((variable: ObservationVariable) => !variable.factor);
                }
            );
    }

    loadAll() {
        this.isLoading = true;

        const pagination: any = {
            page: this.page - 1,
            size: this.itemsPerPage
        };
        this.subscriptionManager.add = this.observationService.getPhenotypeAuditRecords(this.studyId, this.datasetId, this.observationUnitId, this.selectedVariable, pagination)
            .pipe(finalize(() => {
                this.isLoading = false;
            }))
            .subscribe(
                (res: HttpResponse<ObservationAudit[]>) => this.onSuccess(res.body, res.headers)
            );
    }

    private onSuccess(data: ObservationAudit[], headers) {
        this.totalItems = headers.get('X-Total-Count');
        this.queryCount = this.totalItems;
        this.phenotypeAudits = data;
    }

    resetTable() {
        this.page = 1;
        this.previousPage = 1;
        this.loadAll();
    }

    clear() {
        this.activeModal.dismiss('cancel');
        if ((<any>window.parent).closeModal) {
            (<any>window.parent).closeModal();
        }
    }

    loadPage(page: number) {
        if (page !== this.previousPage) {
            this.previousPage = page;
            this.loadAll();
        }
    }

    formatDate(date: string): string {
        return formatDateToUTC(date, DateFormatEnum.ISO_8601_AND_TIME) + ' UTC';
    }

}
